import type { IProductDetails } from '@allesauto/utils/interfaces';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showCartNotification } from '@/store/redux/actions/app';

import { useAddToCart } from './shoppingCart';
import { vehicleToCartItemInput } from '../converters/vehicleToCartItemInput';

export const useFormatedAddToCart = () => {
  const { addToCart, loading } = useAddToCart();
  const dispatch = useDispatch();

  const onAddToCartClick = useCallback(
    async (product: IProductDetails) => {
      try {
        const cart = await addToCart([vehicleToCartItemInput(product)]);

        if (cart && cart.items && cart.items.length) {
          setTimeout(() => {
            dispatch(showCartNotification());
          }, 1000);
        }
      } catch (e) {
        // the error is handled by the apollo errorHandler
      }
    },
    [addToCart, dispatch]
  );

  return {
    onAddToCartClick,
    loading,
  };
};
